import { render } from "./DeviceFrame.vue?vue&type=template&id=3ee56355&scoped=true&ts=true"
import script from "./DeviceFrame.vue?vue&type=script&lang=ts"
export * from "./DeviceFrame.vue?vue&type=script&lang=ts"

import "./DeviceFrame.vue?vue&type=style&index=0&id=3ee56355&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee56355"]])

export default __exports__